import { defineComponent as L, onMounted as g, onUnmounted as h, unref as j, ref as S, provide as k, computed as y, inject as C } from "vue";
import { useId as E } from "./index327.js";
import { render as O } from "./index345.js";
let i = Symbol("LabelContext");
function p() {
  let t = C(i, null);
  if (t === null) {
    let r = new Error("You used a <Label /> component, but it is not inside a parent.");
    throw Error.captureStackTrace && Error.captureStackTrace(r, p), r;
  }
  return t;
}
function T({ slot: t = {}, name: r = "Label", props: a = {} } = {}) {
  let e = S([]);
  function o(l) {
    return e.value.push(l), () => {
      let n = e.value.indexOf(l);
      n !== -1 && e.value.splice(n, 1);
    };
  }
  return k(i, { register: o, slot: t, name: r, props: a }), y(() => e.value.length > 0 ? e.value.join(" ") : void 0);
}
let A = L({ name: "Label", props: { as: { type: [Object, String], default: "label" }, passive: { type: [Boolean], default: !1 }, id: { type: String, default: null } }, setup(t, { slots: r, attrs: a }) {
  var e;
  let o = (e = t.id) != null ? e : `headlessui-label-${E()}`, l = p();
  return g(() => h(l.register(o))), () => {
    let { name: n = "Label", slot: d = {}, props: c = {} } = l, { passive: m, ...u } = t, s = { ...Object.entries(c).reduce((f, [b, v]) => Object.assign(f, { [b]: j(v) }), {}), id: o };
    return m && (delete s.onClick, delete s.htmlFor, delete u.onClick), O({ ourProps: s, theirProps: u, slot: d, attrs: a, slots: r, name: n });
  };
} });
export {
  A as Label,
  T as useLabels
};
